import { useMemo } from 'react';
import { SizeType } from '@tradingblock/types';
import { getTableSize, useWindowSizeContext } from '@tradingblock/components';
export function useBlockTableSize(tableWidth: SizeType): SizeType {
  const { width } = useWindowSizeContext();
  const size = useMemo(() => getTableSize(tableWidth, width), [width, tableWidth]);
  return size;
}
